export const isAzureSignalRServiceUrl = (url?: string): boolean => {
    if (!url) {
        return false;
    }

    try {
        const hostname = new URL(url, typeof window !== 'undefined' ? window.location.origin : 'http://localhost').hostname.toLowerCase();
        return hostname === 'service.signalr.net' || hostname.endsWith('.service.signalr.net');
    } catch {
        return /service\.signalr\.net/i.test(url);
    }
};
